import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ThemeService } from 'src/app/services/ux/theme.service';

@Component({
  selector: 'app-register-view',
  templateUrl: './register-view.component.html',
  styleUrls: ['./register-view.component.scss']
})
export class RegisterViewComponent implements OnInit {
  @Output() registerSuccess = new EventEmitter<any>();

  private isCaptchaValid = false;

  constructor(
    private authSv: AuthService,
    public theme: ThemeService
  ) {
  }

  ngOnInit(): void {
    /** @todo Add google recaptcha and remove the next line */
    this.captchaResolved(null);
  }

  async register(form) {
    if (!this.isCaptchaValid) {
      return;
    }

    const { email, password, name } = form.value;

    await this.authSv.signUp(name, email, password);

    this.registerSuccess.emit();
  }

  captchaResolved(ev) {
    this.isCaptchaValid = true;
  }
}
